// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1-Q13","itemTitle":"ClientEmergencyInfo_itemTitle__3DuPf","itemText":"ClientEmergencyInfo_itemText__3YJU6"};